module.exports = __webpack_public_path__ + "static/media/mortgage-coach-opt-in.293b1785.gif";